// extracted by mini-css-extract-plugin
module.exports = {"saveMessage":"App_saveMessage__14q6F","active":"App_active__jkTxl"};